// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"SuccessIcon_keto_checkmark__jD411","fill_blue":"SuccessIcon_keto_fill_blue__1y4XQ","scale":"SuccessIcon_keto_scale__2obgJ","circle":"SuccessIcon_keto_circle__1dxbL"};